import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './app.state';
import { Observable } from 'rxjs/Observable';
import { NavigationEnd, Router } from '@angular/router';
import { selectAppReady } from './core/core.selector';
import { SourceAppService } from './core/services/source-app.service';

import '../style/app.scss';
import { animate, AnimationEvent, group, state, style, transition, trigger } from '@angular/animations';

/**
 * Main App Component.
 *
 * Dispatches requests to load config and contracts.
 */
@Component({
    selector: 'ssf-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')],
    animations: [
        trigger('slideInOut', [
            state('void', style({
                'transform': 'translateY(-100%)'
            })),
            transition(':enter', [group([
                    animate('800ms ease-in-out', style({'transform': 'translateY(0)'}))
                ]
            )]),
            transition(':leave', [group([
                    animate('800ms ease-in-out', style({'transform': 'translateY(-100%)'}))
                ]
            )]),
        ]),

        trigger('fadeInOut', [
            state('void', style({
                'opacity': '0'
            })),
            transition(':enter', [group([
                    animate('800ms ease-in-out', style({'opacity': '1'}))
                ]
            )]),
            transition('* => out', [group([
                    animate('700ms ease-in-out', style({'opacity': '0'}))
                ]
            )]),
        ])
    ]
})
export class AppComponent {
    public showHeader = false;
    public appReady$: Observable<boolean>;
    // if true, there is an ongoing log-out process
    public loggingOut = false;
    public animationState = 'in';
    public bodyVisible = true;

    constructor(private store: Store<AppState>, private router: Router, public sourceService: SourceAppService) {
        this.appReady$ = this.store.select(selectAppReady);

        this.router.events.filter(e => e instanceof NavigationEnd).subscribe(route => {
            const url = (route as NavigationEnd).url;
            this.showHeader = url.indexOf('expired') === -1  &&  url.indexOf('401') === -1
            && url.indexOf('logout') === -1;
        });
    }

    onLogout() {
        this.loggingOut = true;
        this.animationState = 'out';
    }

    onAnimationDone(event: AnimationEvent) {
        if (event.toState === 'out') {
            this.bodyVisible = false;
        }
        if (this.sourceService.isFromCps()) {
            this.loggingOut = false;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.component.ts